import React, { useEffect, useRef } from "react";

const PrintLabel = () => {
  const hasDownloadedRef = useRef(false);

  useEffect(() => {
    if (!hasDownloadedRef.current) {
      const downloadExeFile = () => {
        const link = document.createElement("a");
        link.href = "/print_label.exe";
        link.download = "print_label.exe";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        console.log("📥 Download started: print_label.exe");
        hasDownloadedRef.current = true;
      };

      downloadExeFile();
    }
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Print Label</h2>
      <p>
        If the download doesn't start automatically, please check your browser
        settings.
      </p>
    </div>
  );
};

export default PrintLabel;
